<template>
  <v-col cols="12" class="px-md-1">
    <v-expansion-panels v-model="status" flat class="rounded-0">
      <v-expansion-panel class="ev-2 rounded-0">
        <v-expansion-panel-header
          class="py-0 pl-2 pr-4"
          expand-icon="mdi-menu-down"
        >
          <div class="center-right">
            <span class="body2-regular">راننده</span>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="pa-0">
          <div
            class="
              d-flex
              justify-space-between
              align-center
              border-top
              pt-3
              mx-1
            "
          >
            <pelak
              v-if="!!load.driverInfo[0].shomare_pelak"
              :pelak="load.driverInfo[0].shomare_pelak"
              style="max-width: 100px"
            ></pelak>
            <div class="panel-content center-right">
              <v-btn
                :href="`tel:${load.driverInfo[0].username}`"
                outlined
                small
                color="success"
                class="mr-auto border-2 py-4"
              >
                <v-icon left dark> mdi-phone</v-icon>
                تماس
              </v-btn>
            </div>
          </div>
          <div class="pt-3 mx-1">
            <div class="mb-2 pb-05">
              <span class="body2-light pl-1">نام و نام‌خانوادگی:</span>
              {{
                load.driverInfo[0].full_name
                  ? load.driverInfo[0].full_name
                  : "نامشخص"
              }}
            </div>
            <div class="mb-2 pb-05">
              <span class="body2-light pl-1">کدملی:</span>
              {{
                load.driverInfo[0].nationalCode
                  ? load.driverInfo[0].nationalCode
                  : "نامشخص"
              }}
            </div>
            <div class="mb-2 pb-05">
              <span class="body2-light pl-1">شماره‌تماس:</span>
              {{
                load.driverInfo[0].username
                  ? load.driverInfo[0].username
                  : "نامشخص"
              }}
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>

<script>
import Pelak from "./NewPelak.vue";

export default {
  name: "DriverDetailPanel",
  components: {
    Pelak,
  },
  props: {
    load: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      status: 0,
    };
  },
};
</script>

<style scoped>
.v-expansion-panel-header {
  height: 20px !important;
  max-height: 20px !important;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.center-right {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.border-2 {
  border-width: 2px;
}
</style>
